/** @format */

import React from "react";

const UberLogo = ({ color, width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 106 106"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M105.552 4.64868C105.552 2.43951 103.761 0.648682 101.552 0.648682H4.44836C2.2392 0.648682 0.448364 2.43951 0.448364 4.64868V60.3701H35V38.2003C35 36.5434 36.3431 35.2003 38 35.2003H105.552V4.64868Z"
        fill={color}
      />
      <path
        d="M105.552 46.0305H71V68.2003C71 69.8571 69.6569 71.2003 68 71.2003H0.448364V101.752C0.448364 103.961 2.2392 105.752 4.44836 105.752H101.552C103.761 105.752 105.552 103.961 105.552 101.752V46.0305Z"
        fill={color}
      />
    </svg>
  );
};

export default UberLogo;
